// src/components/Toast.js
import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

export const Toast = ({ toast, onRemove }) => {
  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-system-success" />;
      case 'error':
        return <XCircle className="h-5 w-5 text-system-error" />;
      case 'warning':
        return <AlertCircle className="h-5 w-5 text-vibrant-orange-vo3" />;
      default:
        return <Info className="h-5 w-5 text-electric-blue" />;
    }
  };

  // A neutral surface with a status-coloured rule. Red is reserved for
  // something that has actually gone wrong; warnings use orange deep.
  const getBgColor = () => {
    switch (toast.type) {
      case 'success':
        return 'bg-n1 border-system-success';
      case 'error':
        return 'bg-n1 border-system-error';
      case 'warning':
        return 'bg-n1 border-vibrant-orange-vo3';
      default:
        return 'bg-n1 border-n3';
    }
  };

  return (
    <div className={`p-4 border ${getBgColor()} shadow-lg`}>
      <div className="flex">
        <div className="flex-shrink-0">
          {getIcon()}
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-gray-900">{toast.message}</p>
        </div>
        <div className="ml-4 flex-shrink-0 flex">
          <button
            className=" inline-flex text-n5 hover:text-gray-700 hover:bg-gray-200 p-1.5 transition-colors duration-200"
            onClick={() => onRemove(toast.id)}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};